<template>
  <v-card
    class="mx-auto px-3 py-3"
    max-width="344"
    height="300"
    v-show="!loading"
    outlined
    flat
    hover
  >
    <p class="text-right">
      <YearMonthDay :value="item.SHOW_SEND_TIME" />
    </p>

    <Avatar :src="item.TO_USER_AVATER" :size="100" />

    <h4 class="text-center mt-2 mb-2">
      <span style="margin-right: 1rem">To</span>{{ item.TO_USER_NAME }}
      <span v-if="item.NICE_COUNT > 0" class="ml-3"
        ><v-icon small color="orange darken-2">mdi-thumb-up</v-icon></span
      >
      <span v-if="item.NICE_COUNT > 0" style="margin-left: 5px"
        ><strong>{{ item.NICE_COUNT }}</strong></span
      >
    </h4>

    <p class="text-left excerpt">
      {{ item.SEND_COMMENT | omittedText }}
    </p>
    <h4 class="text-right">
      <span class="mr-2">From</span><span>{{ item.SEND_USER_NAME }}</span>
    </h4>
  </v-card>
</template>

<script>
export default {
  name: 'Card',
  props: {
    item: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    },
  },

  filters: {
    omittedText(text) {
      return text.length > 10 ? text.slice(0, 25) + '…' : text;
    },
  },
};
</script>

<style scoped>
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 0.5rem;
  border-top: 5px solid #e55513;
}

.excerpt {
  height: 3.25rem;
}
</style>
